import header from "./modules/header";
import anchors from "./modules/anchors";
import slider from "./modules/slider";
import hoverEffects from "./modules/hoverEffects";
import filter from "./modules/filter";
import forms from "./modules/forms";
import anim from "./modules/anim";
import popup from "./modules/popup";
import cart from "./modules/cart";
import backBtn from "./modules/backBtn";
import tabs from "./modules/tabs";

document.addEventListener('DOMContentLoaded', ()=> {
    header();
    anchors();
    slider();
    hoverEffects();
    filter();
    forms();
    anim();
    popup();
    cart();
    backBtn();
    tabs();
});